/**
 * The version number of app.
 * @constant
 * @type {string}
 */

export const VERSION_TBX_APP = '5.2.0';
